import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import ButtonBase from '@material-ui/core/ButtonBase';
import { CircularProgress } from '@mui/material';
import VIcon from '../VIcon/VIcon';
import { createIconButtonStyles } from './styles';

const VIconButton = (props) => {
  const {
    classes,
    icon,
    loading,
    disabled,
    color,
    size,
    className,
    style,
    onClick,
    type,
    autoFocus,
    href,
    target,
  } = props;

  const getButtonClasses = (classes) => {
    const buttonClasses = [classes.base];
    const buttonColor = color ?? 'main';
    buttonClasses.push(classes[buttonColor]);

    const buttonSize = size ?? 'medium';
    buttonClasses.push(classes[buttonSize]);

    if (className) buttonClasses.push(className);

    return buttonClasses.join(' ');
  };

  const getIconColor = () => {
    if (color === 'white') return 'black';
    return 'white';
  };

  const getIconSize = () => {
    if (size === 'small') return 18;
    if (size === 'large') return 36;
    return 24;
  };

  const buttonClasses = getButtonClasses(classes);
  const iconColor = getIconColor();
  const iconSize = getIconSize();

  return (
    <ButtonBase
      style={style}
      onClick={onClick}
      disabled={disabled || loading}
      className={buttonClasses}
      type={type}
      autoFocus={autoFocus}
      href={href}
      target={target}
    >
      {loading ? (
        <CircularProgress size={iconSize} style={{ color: iconColor }} />
      ) : (
        <VIcon name={icon} size={iconSize} color={iconColor} />
      )}
    </ButtonBase>
  );
};

const styles = createIconButtonStyles;

export default withStyles(styles)(VIconButton);
